import React from 'react';
import { rentalSteps } from '../data/mockData';
import { Calendar, Home, Sparkles, RefreshCw } from 'lucide-react';

const icons = [Calendar, Home, Sparkles, RefreshCw];

const HowItWorks = () => {
  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif text-neutral-900 mb-4">¿Cómo alquilar en Morea?</h2>
          <p className="text-lg text-neutral-600 font-light max-w-2xl mx-auto">
            En Morea te atendemos con cita para que puedas probarte vestidos con tranquilidad y recibir asesoría personalizada.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-6xl mx-auto">
          {rentalSteps.map((step, index) => {
            const Icon = icons[index];
            return (
              <div 
                key={step.id}
                className="relative text-center group"
              >
                {/* Step Number */}
                <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 w-12 h-12 bg-neutral-900 text-white rounded-full flex items-center justify-center text-xl font-serif z-10">
                  {step.id}
                </div>

                {/* Card */}
                <div className="pt-10 pb-8 px-6 bg-neutral-50 rounded-sm hover:bg-white hover:shadow-xl transition-all duration-300 h-full border border-neutral-100">
                  <div className="flex justify-center mb-6">
                    <div className="w-16 h-16 bg-neutral-900 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <Icon className="w-8 h-8 text-white" />
                    </div>
                  </div>
                  <h3 className="text-xl font-serif text-neutral-900 mb-3">{step.title}</h3>
                  <p className="text-neutral-600 font-light leading-relaxed">{step.description}</p>
                </div>

                {/* Connector Line */}
                {index < rentalSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-16 left-full w-full h-0.5 bg-neutral-200 -z-10"></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
